export default __webpack_public_path__ + "48fb2927d790a09d39515878f0f0d088.png";